// ModelUI/ResetPasswordModal/ResetPasswordModal.js
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react"; 
import "./ResetPasswordModal.css";

const ResetPasswordModal = ({ onClose, onReset }) => {
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  // Password validation rules
  const validatePassword = (password) => {
    if (password.length < 8) {
      return "Password must be at least 8 characters";
    }
    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least one uppercase letter";
    }
    if (!/[a-z]/.test(password)) {
      return "Password must contain at least one lowercase letter";
    }
    if (!/[0-9]/.test(password)) {
      return "Password must contain at least one number";
    }
    if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) {
      return "Password must contain at least one special character";
    }
    return "";
  };

  const handleReset = () => {
    const validationError = validatePassword(newPassword);
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    onReset(newPassword.trim());
    setNewPassword("");
  };

  return (
    <div className="add-section-modal-overlay">
      <div className="add-section-modal">
        <h5>Reset Password</h5>

        <div className="password-input-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            style={{ height: 40 }}
            className="form-control"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
          />
          <span
            className="password-toggle-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </span>
        </div>

        {/* Show validation error */}
        {error && <p className="error-text">{error}</p>}

        <div className="add-section-buttons">
          <button className="popup-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="popup-add-btn" onClick={handleReset}>
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
